import { useEffect, useRef, useState } from "react";
import { Route, useHistory, useLocation } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { useWaterSystemSearchModal } from "./WaterSystemSearchModalContext";
import { GET_WATER_SYSTEM_SUMMARY } from "../../queries/publicQrys/SystemHeaderViewQrys";
import { setPwsIdCookie } from "../../utilities/commonFunctions/pwsIdCookie";

const WaterSystemGuardRoute = ({ component: Component, ...rest }) => {
  const { showSystemSelectModal, setShowSystemSelectModal, isRestoringFromCookie, setSelectedWaterSystem } = useWaterSystemSearchModal();
  const history = useHistory();
  const location = useLocation();
  const pwsIdFromUrl = new URLSearchParams(location.search).get("pwsId");
  const lastProcessedPwsIdRef = useRef(null);
  const guardModalHasBeenSeenRef = useRef(false);

  const [urlFetchDone, setUrlFetchDone] = useState(false);

  const [fetchUrlSystem] = useLazyQuery(GET_WATER_SYSTEM_SUMMARY, {
    onCompleted: (data) => {
      if (data?.getWaterSystemSummary) {
        const waterSystem = data.getWaterSystemSummary;
        sessionStorage.setItem("selectedWaterSystem", JSON.stringify(waterSystem));
        setPwsIdCookie(waterSystem.pwsId);
        setSelectedWaterSystem(waterSystem);
      }
      setUrlFetchDone(true);
    },
    onError: () => setUrlFetchDone(true),
  });

  useEffect(() => {
    if (pwsIdFromUrl && pwsIdFromUrl !== lastProcessedPwsIdRef.current) {
      lastProcessedPwsIdRef.current = pwsIdFromUrl;
      setUrlFetchDone(false);
      fetchUrlSystem({ variables: { pwsId: pwsIdFromUrl } });
    }
  }, [pwsIdFromUrl, fetchUrlSystem]);

  const selectedWaterSystem = JSON.parse(sessionStorage.getItem("selectedWaterSystem") || "{}");
  const hasWaterSystem = !!(selectedWaterSystem && Object.keys(selectedWaterSystem).length > 0);

  const isFetchingUrlSystem = !!pwsIdFromUrl && !urlFetchDone;
  const readyToRender = isFetchingUrlSystem ? false : hasWaterSystem;

  useEffect(() => {
    if (!readyToRender && !isRestoringFromCookie && !isFetchingUrlSystem && !showSystemSelectModal && !guardModalHasBeenSeenRef.current) {
      setShowSystemSelectModal(true);
    }
  }, [readyToRender, isRestoringFromCookie, isFetchingUrlSystem, showSystemSelectModal, setShowSystemSelectModal]);

  useEffect(() => {
    if (showSystemSelectModal) {
      guardModalHasBeenSeenRef.current = true;
    }
  }, [showSystemSelectModal]);

  useEffect(() => {
    if (guardModalHasBeenSeenRef.current && !showSystemSelectModal) {
      const system = JSON.parse(sessionStorage.getItem("selectedWaterSystem") || "{}");
      if (!system || Object.keys(system).length === 0) {
        guardModalHasBeenSeenRef.current = false;
        history.goBack();
      }
    }
  }, [showSystemSelectModal, history]);

  return (
    <Route
      {...rest}
      render={(props) => readyToRender ? <Component {...props} /> : null}
    />
  );
};

export default WaterSystemGuardRoute;
